import { styled } from '@clickcease/cc-client-components-lib'

export const UserMenuStyled = styled('div', {
  width: 'fit-content',
  minWidth: '130px',
  background: '#FFFFFF',
  paddingBlock: '$4',
  boxShadow: '0px 5px 30px rgba(102, 102, 102, 0.16)',
  borderRadius: '$normal',
  '@laptop': {
    position: 'absolute',
  },
})

export const UserMenuOption = styled('div', {
  width: 'calc(100% - 16px)',
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
  cursor: 'pointer',
  padding: '$2 $4',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  ['&:hover']: {
    color: '$primaryColor',
    background: '$tableHovered',
  },

  ['isActive']: {
    fontWeight: '$rb',
    color: '$primaryColor',
    background: '$tableSelected',
  },
})

export const UserMenuTrigger = styled('button', {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  position: 'relative',
  //for font awesome, differs from font size
  fontSize: '$h3',
  padding: '0px',

  '> svg': {
    // svg from the left
    marginInlineEnd: '$5',
  },
  'span ~ svg': {
    // svg from the right
    marginInlineEnd: '0',
    marginInlineStart: '$5',
    fontSize: '$sm',
  },

  '&:hover > *': {
    color: '$buttonHovered',
  },

  variants: {
    singleAccount: {
      true: {
        cursor: 'default',
        '&:hover > *': {
          color: '$black',
        },
      },
    },
  },
})
